import * as TYPES from '../signup-actiontypes';
import * as CREATE_ACCOUNT from './create-account-actiontype';

export const setPasswordRules = (passwordRules) => ({
  type: TYPES.LOAD_PASSWORD_RULES,
  password: {
    minLength: passwordRules.minimumLength,
    capitalLetters: passwordRules.numOfCapitalLetters,
    numbers: passwordRules.numOfNumbers,
    specialCharacters: passwordRules.numOfSpecialCharacters,
  },
});

export const setEmailAddress = (emailAddress) => ({
  type: CREATE_ACCOUNT.SET_EMAIL,
  email: emailAddress,
  username: emailAddress,
});

export const clearPatientData = () => ({
  type: CREATE_ACCOUNT.CLEAR_PATIENT_DATA,
});

export const clearPasswordFields = () => ({
  type: CREATE_ACCOUNT.CLEAR_PASSWORD,
});
